(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-support"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gp-support'))customElements.define('gp-support',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal,details=this.querySelector('details'),summary=this.querySelector('summary');document.addEventListener('pointerdown',e=>{if(details.open&&!this.contains(e.target))details.open=false},{signal});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&details.open){details.open=false;summary.focus()}},{signal})}
disconnectedCallback(){this.abort?.abort();this.abort=null}
});
  } catch(e) { console.error(e); }
})();

})();
